<a
  class="btn btn-light btn-circle"
  routerLink="/inquiries/message-feed"
  i18n-matTooltip
  matTooltip="Unread Messages. Click to view your messages in the Message Feed."
  matTooltipPosition="below"
>
  <i class="fal fa-envelope text-lg"></i>
  <sup [hidden]="!unreadCount" class="badge">{{ unreadCount }}</sup>
</a>
